export interface IOrderNotification {
	id: string;
	entityType: string;
	orderId: string;
	creationDateTime: string;
	notificationType: NotificationType;
	notificationValues: { [key: string]: string };
}

export enum NotificationType {
	SwiftNotification,
	UnderwritingChanged
}
